/**
 * @ngdoc controller
 */
angular
  .module('dwtCreateQRFClaimModule')
  .controller('CreateDwtQRFRequestController', [
    '$scope',
    '$sessionStorage',
    '$stateParams',
    'CreateDwtQRFReqService',
    'DwtCreateQRF',
    '$log',
    '$filter',
    '$timeout',
    '$state',
    'userGroupService',
    '$anchorScroll',
    '$location',
    function (
      $scope,
      $sessionStorage,
      $stateParams,
      CreateDwtQRFReqService,
      DwtCreateQRF,
      $log,
      $filter,
      $timeout,
      $state,
      userGroupService,
      $anchorScroll,
      $location
    ) {
      $scope.emailPattern = appConstant.EMAIL_REGEX_PATTERN;

      $scope.qrfClaimAgree = false;
      $scope.languageCode = 'EN';
      $scope.taxReclaimIndexId = $sessionStorage.taxReclaimIndexId;
      $scope.eventId = $stateParams.eventId;
      $scope.eventName = $stateParams.eventName;
      $scope.eventStatus = $stateParams.eventStatus;
      $scope.flag = $stateParams.flag;
      $scope.issuerId = $stateParams.issuerId;
      $scope.issuerName = $stateParams.issuerName;
      $scope.dwtPerSecurity = $stateParams.dwtPerSecurity;
      $scope.qrfEndDate = $stateParams.qrfEndDate;
      $scope.peFlag = $stateParams.peFlag;
      $scope.qrfFlag = $stateParams.qrfFlag;
      $scope.extReqFlag = $stateParams.extReqFlag;
      $scope.shareClassName = $stateParams.shareClassName;
      $scope.extensionReqFlagForQRF = $stateParams.extensionReqFlagForQRF;
      $scope.extensionReqFlagForPE = $stateParams.extensionReqFlagForPE;
      $scope.isin = $stateParams.isin;
      $scope.rsinMandatory = false;
      $scope.tinMandatory = false;
      var availableCountry = { isoCountryCode: null, countryName: null };
      // Below is the function used to fetch issuer logo
      userGroupService.getIssuerGroupLogo($scope.issuerId).then(
        function (response) {
          $scope.issuerGroupDetails = response.data;
        },
        function (error) {
          $log.debug(error);
        }
      );

      // The name of the country that the user is creating or editing
      // It is overwritten when the qrf claim is fetched from the backend (on editing a qrf claim)
      $scope.qrfClaimCountryName = null;

      CreateDwtQRFReqService.getCreateGMDropDown($scope.languageCode)
        .query()
        .$promise.then(
          function (countries) {
            $scope.countryList = countries.countries;
            if ($scope.qrfClaimCountryName) {
              $scope.selectedCountry = $filter('filter')(
                $scope.countryList,
                { countryName: $scope.qrfClaimCountryName },
                true
              );
              $scope.createPEReqModal.country =
                $scope.selectedCountry[0].isoCountryCode;
            } else {
              // default to NLD when creating a new claim
              $scope.selectedCountry = $filter('filter')(
                $scope.countryList,
                { isoCountryCode: 'NLD' },
                true
              );
            }
            $scope.evaluateRsinAndTinMandatory();
          },
          function (error) {
            $log.debug(error);
          }
        );
      //below function to get payment reference number
      if ($scope.eventId) {
        CreateDwtQRFReqService.getPaymentRefrenceNumber(
          $sessionStorage.groupId,
          $scope.eventId
        ).then(
          function (data) {
            $scope.createQRFReqModal.paymentReference = data.data.paymentRefNo;
          },
          function (error) {
            $log.debug(error);
          }
        );
      }

      $scope.successCallback = function (response) {
        $scope.loading = false;
        if ($scope.createQRFReqModal.searchclickedflag) {
          $scope.createQRFReqModal.rsinNumber = response.data.rsinNumber;
          $scope.createQRFReqModal.tin = response.data.tin;
          $scope.createQRFReqModal.securityAccountNo =
            response.data.securityAccountNo;
          $scope.createQRFReqModal.basedOnArticle4a = response.data.basedOnArticle4a;
          $scope.createQRFReqModal.qualificationLetterNumber = response.data.qualificationLetterNumber;
          $scope.createQRFReqModal.firstName = response.data.firstName;
          if (
            response.data.firstName === '' ||
            response.data.firstName === null ||
            response.data.firstName === undefined
          ) {
            $scope.createQRFReqModal.lastName = response.data.lastName;
          } else {
            $scope.createQRFReqModal.lastName =
              response.data.firstName + ' ' + response.data.lastName;
          }
          $scope.createQRFReqModal.postalCode = response.data.postalCode;
          $scope.createQRFReqModal.email = response.data.email;
          $scope.createQRFReqModal.city = response.data.city;
          $scope.createQRFReqModal.country = response.data.country;
          $scope.createQRFReqModal.phoneNumber = response.data.phoneNumber;
          $scope.createQRFReqModal.address = response.data.address;
          $scope.createQRFReqModal.paymentReference =
            response.data.paymentReference;
          $scope.createQRFReqModal.fundManager = response.data.fundManager;
          $scope.createQRFclaimSuccess = '';
          $scope.createQRFclaimErrRes = '';
          $scope.createQRFSearchclaimErrRes = '';
        } else if ($scope.createQRFReqModal.onloadFlag) {
          $scope.createQRFReqModal = new DwtCreateQRF(
            $stateParams,
            response.data.claimsVO.intermediaryId
          );
          $scope.createQRFReqModal.securityAccountNo =
            response.data.claimsVO.securityAccNumber;
          $scope.createQRFReqModal.basedOnArticle4a = response.data.basedOnArticle4a;
          $scope.createQRFReqModal.qualificationLetterNumber = response.data.qualificationLetterNumber;
          $scope.createQRFReqModal.rsinNumber = response.data.rsin;
          $scope.createQRFReqModal.tin = response.data.tin;
          $scope.createQRFReqModal.lastName =
            response.data.claimsVO.beneficalOwnerName;
          $scope.createQRFReqModal.postalCode = response.data.postalCode;
          $scope.createQRFReqModal.email = response.data.email;
          $scope.createQRFReqModal.city = response.data.city;
          $scope.createQRFReqModal.phoneNumber = response.data.phoneNo;
          $scope.createQRFReqModal.address = response.data.address;
          $scope.createQRFReqModal.paymentReference =
            response.data.paymentReference;
          $scope.createQRFReqModal.position = parseInt(
            response.data.claimsVO.position,
            10
          );
          $scope.createQRFReqModal.fundManager =
            response.data.claimsVO.fundManager;
          $scope.createQRFclaimSuccess = '';
          $scope.createQRFclaimErrRes = '';
          $scope.shareClassName = response.data.claimsVO.shareclassName;
          $scope.createQRFSearchclaimErrRes = '';

          $scope.qrfClaimCountryName = response.data.country;
          if ($scope.countryList) {
            if (
              $filter('filter')(
                $scope.countryList,
                { countryName: response.data.country },
                true
              ).length > 0
            ) {
              $scope.createQRFReqModal.country =
                $scope.selectedCountry[0].isoCountryCode;
              $scope.selectedCountry = $filter('filter')(
                $scope.countryList,
                { countryName: response.data.country },
                true
              );
              $scope.evaluateRsinAndTinMandatory();
            } else {
              availableCountry.countryName = response.data.country;
              $scope.countryList = $scope.countryList.concat(availableCountry);
              $scope.createQRFReqModal.country = response.data.country;
              $scope.selectedCountry = $filter('filter')(
                $scope.countryList,
                { countryName: response.data.country },
                true
              );
            }
          }
        } else {
          $scope.createQRFclaimSuccess = response.data.message;
          $scope.createQRFclaimErrRes = '';
          $scope.createQRFSearchclaimErrRes = '';
          $('#successMsg').modal('show');
          $timeout(function () {
            $('#successMsg').modal('hide');
            $('.modal-backdrop').remove();
            $state.go('dwtDetails', {
              selectedIndex: $scope.taxReclaimIndexId,
              eventId: $scope.eventId,
              flag: $scope.flag,
              issuerId: $scope.issuerId,
              issuerName: $scope.issuerName,
              eventStatus: $scope.eventStatus,
              claimsList: $scope.claimsArray,
              eventName: $scope.eventName,
              dwtPerSecurity: $scope.dwtPerSecurity,
              qrfEndDate: $scope.qrfEndDate,
              peFlag: $scope.peFlag,
              qrfFlag: $scope.qrfFlag,
              extensionReqFlagForQRF: $scope.extensionReqFlagForQRF,
              extensionReqFlagForPE: $scope.extensionReqFlagForPE,
              extReqFlag: $scope.extReqFlag,
              navFrom: 'qrfClaim',
              breadCrumbDetails: [$scope.eventName],
            });
          }, 2000);
        }
      };
      $scope.errorCallback = function (error) {
        $scope.loading = false;
        $scope.createQRFclaimSuccess = '';
        $scope.createQRFSearchclaimErrRes = '';
        $scope.createQRFclaimErrRes = '';
        if (!$scope.createQRFReqModal.searchclickedflag) {
          if (error.data.message !== null && undefined !== error.data.message) {
            $scope.createQRFclaimErrRes = error.data.message;
          } else {
            $scope.createQRFclaimErrRes = error.data.errors[0].errorMessage;
          }
        } else {
          $scope.createQRFSearchclaimErrRes =
            'No existing claim found for this input!';
        }
      };
      $scope.changeCountry = function (selectedCountry) {
        $scope.createQRFReqModal.country = selectedCountry.isoCountryCode;
        $scope.evaluateRsinAndTinMandatory();
      };
      $scope.createQRFReqModal = new DwtCreateQRF(
        $stateParams,
        $stateParams.intermediaryId
      );
      if ($stateParams.qrfClaimId) {
        $scope.qrfClaimAgree = true;
        $scope.createQRFReqModal.viewDWTQRFRequest(
          $scope.successCallback,
          $scope.errorCallback
        );
      }
      $scope.cancelClaimModal = function () {
        $scope.modalHeader = 'Cancel claim';
        $scope.modalBody = 'Are you sure you wanted to cancel?';
        $scope.modalFooter = '';
        $scope.modalLeftButton = 'Yes';
        $scope.modalRightButton = 'No';
      };
      $scope.createDwtQRFRequestLoading = function () {
        $scope.loading = true;
        $location.hash('qrfClaim');
        $anchorScroll();
      };
      $scope.navToOverviewPage = function () {
        $state.go('taxReclaimHome', {
          selectedIndex: $scope.taxReclaimIndexId,
        });
      };

      $scope.checkPosition = function () {
        if ($scope.createQRFReqModal.position === 0) {
          $scope.qrfClaimForm.position.$setDirty();
          $scope.qrfClaimForm.position.$setValidity('pattern', false);
        }
      };

      $scope.evaluateRsinAndTinMandatory = function () {
        if ($scope.selectedCountry[0].isoCountryCode === 'NLD') {
          $scope.rsinMandatory = true;
          $scope.tinMandatory = false;
        } else {
          $scope.rsinMandatory = false;
          $scope.tinMandatory = true;
        }
      };
    },
  ]);
